export enum enumBooleanValues {
  'False'= 0,
  'True'= 1
}

export namespace enumBooleanValues {
  export function values() {
    return Object.keys(enumBooleanValues).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}


